
import Vue from "vue";
import {BIconCartFill} from "bootstrap-vue";

export default Vue.extend({
  name: "CartIcon",
  components: {
    BIconCartFill,
  },
});
